import { ref } from 'vue'
import { defineStore } from 'pinia'

type HomePanel = 'noise' | 'scenario'

// 仅管理首页窗口的显示，不改变降噪开关、场景应用状态或保存数据。
// 两个入口共用一个状态，因此展开其中一个会同时收起另一个。
export const useHomePanelStore = defineStore('homePanel', () => {
  const activePanel = ref<HomePanel | null>(null)

  function togglePanel(panel: HomePanel): void {
    activePanel.value = activePanel.value === panel ? null : panel
  }

  function closePanel(panel?: HomePanel): void {
    if (!panel || activePanel.value === panel) activePanel.value = null
  }

  return { activePanel, togglePanel, closePanel }
})
